import React from 'react';
import { FeatureLabel } from '../../../../components/FeatureLabel';
import { Tour3d16 } from '@cian/ui-kit';
import { useOfferContext } from '../../../../context';

export function TourLabelContainer() {
  const { hasTour } = useOfferContext();

  if (!hasTour) {
    return null;
  }

  return <FeatureLabel icon={<Tour3d16 color="white_100" />} title={'Объявление с 3D-туром'} />;
}
